import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=1f66875c&scoped=true&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"
import style0 from "./user-info.vue?vue&type=style&index=0&id=1f66875c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66875c",
  null
  
)

export default component.exports